import { ReactElement } from 'react';

interface Props {
  th: string[];
  td: ReactElement | ReactElement[];
  empty: boolean;
}

const Table = ({ th, td, empty }: Props): ReactElement => (
  <div>
    {!empty ? (
      <table className="table table-striped">
        <thead>
          <tr className="grid">
            {th.map((item, i) => (
              <th
                key={item}
                className={`sorting ${th.length - 1 === i ? 'text-left' : ''}`}
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {td}
        </tbody>
      </table>
    ) : (
      <div className="table table-striped alert alert-warning" role="alert">
        Nenhum registro encontrado
      </div>
    )}
  </div>
);

export default Table;
